<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
    <CodePop></CodePop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
button:focus,
a:focus,
input:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue